/**
 * Client-safe types + small label maps for /problemes pages.
 * The heavy PROBLEMES array lives in `problemes-data.server.ts` to
 * keep ~28 kB gzip out of the client bundle.
 */

export interface Probleme {
  slug: string
  title: string
  urgency: 'urgent' | 'semi-urgent' | 'planifiable'
  serviceSlugs: string[]
  shortDesc: string
  description: string
  whatToDo: string[]
  dontDo: string[]
  avgCost: string
  faq: Array<{ q: string; a: string }>
  aiClaims?: string[]
}

export const URGENCY_LABELS: Record<Probleme['urgency'], { label: string; color: string }> = {
  urgent: { label: 'Urgent', color: 'bg-red-100 text-red-700' },
  'semi-urgent': { label: 'Semi-urgent', color: 'bg-amber-100 text-amber-700' },
  planifiable: { label: 'Planifiable', color: 'bg-blue-100 text-blue-700' },
}
